import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExecutingTaskMonitorService } from '../../services/executing-task-monitor.service';

@Component({
  selector: 'app-spinner-full-page',
  imports: [CommonModule],
  templateUrl: './spinner-full-page.component.html',
  styleUrl: './spinner-full-page.component.scss',
  standalone: true,
})
export class SpinnerFullPageComponent implements OnInit {
  constructor(
    public executingTaskSvc: ExecutingTaskMonitorService,
    private readonly _cdRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.executingTaskSvc.refreshSpinnerTable.subscribe((data) => {
      this._cdRef.detectChanges();
    });
  }
}
